module.exports = __webpack_public_path__ + "static/media/voiture-triste.ec46205c.svg";